import { Badge, type BadgeProps } from '@mantine/core';
import { getContrastColor, type MeetingType } from '@actschurch/ccms-sdk';
import { DEFAULT_TYPE_COLORS } from '../utils/meetingConstants';

interface MeetingTypeBadgeProps extends Omit<BadgeProps, 'children'> {
  type?: MeetingType | null;
  typeID?: number | null;
  typeName?: string | null;
  typeColor?: string | null;
  fallbackName?: string;
}

export function MeetingTypeBadge({
  type,
  typeID,
  typeName,
  typeColor,
  fallbackName,
  variant = 'light',
  size = 'sm',
  ...rest
}: MeetingTypeBadgeProps) {
  const resolvedID = typeID ?? type?.typeID ?? null;
  const name = typeName || type?.name || fallbackName || (resolvedID != null ? `Type ${resolvedID}` : 'Unknown');
  const rawColor = typeColor || type?.color || null;

  if (rawColor && rawColor.startsWith('#')) {
    return (
      <Badge
        variant="filled"
        size={size}
        style={{ backgroundColor: rawColor, color: getContrastColor(rawColor) }}
        styles={{ label: { overflow: 'visible' } }}
        {...rest}
      >
        {name}
      </Badge>
    );
  }

  const color = rawColor || (resolvedID != null ? DEFAULT_TYPE_COLORS[resolvedID] : undefined) || 'grape';
  return (
    <Badge variant={variant} size={size} color={color} styles={{ label: { overflow: 'visible' } }} {...rest}>
      {name}
    </Badge>
  );
}
